import React from 'react';

export default () => (
  <svg width="39" height="40" viewBox="-1 -1 41 42" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(0 1)">
          <path
            d="M9 9.548V1.716s.335-.68.682-.938c.25-.186 1.11-.394 1.11-.394h26.403s.451.209.572.394c.148.228.233.845.233.845v25.99s-.075.62-.233.846c-.167.237-.744.541-.744.541h-6.467"
            stroke="#21304A"
            strokeWidth="2"
            fill="none"
          />
          <rect fill="#21304A" x="12" y="3.211" width="3" height="3" rx="1" />
          <rect fill="#21304A" x="33" y="3.211" width="3" height="3" rx="1" />
          <rect fill="#21304A" x="33" y="9.211" width="3" height="3" rx="1" />
          <rect fill="#21304A" x="33" y="15.211" width="3" height="3" rx="1" />
          <rect fill="#21304A" x="33" y="21.211" width="3" height="3" rx="1" />
          <rect
            stroke="#21304A"
            strokeWidth="2"
            fill="none"
            y="8.4"
            width="31.234"
            height="30.433"
            rx="2"
          />
          <path
            d="M1 27.145l10-8 13 18M19 28.145l4-4 7 6.25"
            stroke="#21304A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <circle stroke="#21304A" strokeWidth="2" fill="none" cx="20.5" cy="16.645" r="2.5" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-media.es6.js